'use es6';

import createForm from 'forms-utils-lib/formDefinition/utils/createForm';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/Form';
const INIT_STATE = {
  currentForm: createForm({}),
  fetchRequestState: RequestState.NOT_REQUESTED
};
export function form(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_FORM:
      return Object.assign({}, state, {
        fetchRequestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_FORM:
      return Object.assign({}, state, {
        fetchRequestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_FORM:
      return Object.assign({}, state, {
        currentForm: action.form
      });
    case Actions.FAIL_GETTING_FORM:
      return Object.assign({}, state, {
        fetchRequestState: RequestState.FAILED.setError(action.error)
      });
    default:
      return state;
  }
}